"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgUsersFamily(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M26 10a3 3 0 100-6 3 3 0 000 6zM14 10a3 3 0 100-6 3 3 0 000 6zM20 21a3 3 0 100-6 3 3 0 000 6z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M24 13h4a4 4 0 014 4v8.636a2 2 0 01-2 2h-1L29.007 36H26M14 36h-3v-8.364h-1a2 2 0 01-2-2V17a4 4 0 014-4h4M16 24a1 1 0 011-1h6a1 1 0 011 1v4.382a1 1 0 01-.553.894l-.894.447a1 1 0 00-.553.896L22.005 36H18v-5.382a1 1 0 00-.553-.894l-.894-.448a1 1 0 01-.553-.894V24z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgUsersFamily;
//# sourceMappingURL=UsersFamily.js.map